import React from 'react';

interface CompanySearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export const CompanySearchBar: React.FC<CompanySearchBarProps> = ({
  value,
  onChange,
  placeholder = 'Search by name, email, or address...'
}) => {
  return (
    <div className="relative">
      <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
        <svg 
          className="w-5 h-5 text-[var(--text-muted)]" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" 
          />
        </svg>
      </div>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label="Search companies"
        className="w-full pl-12 pr-4 py-3 text-base bg-[var(--bg-secondary)] border-2 border-[#EF4421] rounded-lg text-[var(--text-primary)] placeholder-[var(--text-muted)] focus:outline-none focus:ring-2 focus:ring-[#EF4421] focus:border-transparent transition-all"
      />
    </div>
  );
};
